import * as actionTypes from '../../constants/actionTypes';

const initialState = {
  taskList: [],
  isTaskLoading: false,
  isTaskDeletionInProgress: false,
  isAddUpdateTaskInProgress: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_STAGE_TASKS_SUCCESS:
    case actionTypes.GET_STAGE_TASKS_ERROR:
      if (action.payload.taskList) {
        state.taskList = action.payload.taskList.map(task => {
          return {
            ...task,
            open: false,
          };
        });
      } else {
        state.taskList = [];
      }
      return Object.assign({}, state, state.taskList);
    case actionTypes.TOOGLE_ACCORDIAN:
      state.taskList = state.taskList.map(task => {
        if (task.uuid === action.payload.taskId && task.open === false) {
          return {
            ...task,
            open: true,
          };
        } else {
          return {
            ...task,
            open: false,
          };
        }
      });
      return Object.assign({}, state, state.taskList);
    case actionTypes.SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.GET_STAGE_TASKS:
          return Object.assign({}, state, { isTaskLoading: true });
        case actionTypes.CREATE_STAGE_TASK:
        case actionTypes.SAVE_TASK:
          return Object.assign({}, state, { isAddUpdateTaskInProgress: true });
        case actionTypes.DELETE_STAGE_TASK:
          return Object.assign({}, state, { isTaskDeletionInProgress: true });
        default:
          return Object.assign({}, state);
      }
    case actionTypes.HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.GET_STAGE_TASKS:
          return Object.assign({}, state, { isTaskLoading: false });
        case actionTypes.CREATE_STAGE_TASK:
        case actionTypes.SAVE_TASK:
          return Object.assign({}, state, { isAddUpdateTaskInProgress: false });
        case actionTypes.DELETE_STAGE_TASK:
          return Object.assign({}, state, { isTaskDeletionInProgress: false });
        default:
          return Object.assign({}, state);
      }
    default:
      return state;
  }
}
